import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AuthService } from './shared/auth/auth.service';
import { ApplicationInsightsService } from './shared/services/application-insights.service';
import { CoreService } from './shared/services/core.service';
import { LoaderService } from './shared/services/loader.service';
import { MAIN_LOADER_ID, PLP_SCROLL_PROP } from './shop/shared/constants/shared.constants';
import { UtilityFunctions } from './shared/utilities/functions.models';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CoreTranslationService } from './shared/services/translation.service';
import { CultureList } from './shared/culture/culture.model';
import { ItTranslation } from './shared/culture/traslations/it';
import { EnTranslation } from './shared/culture/traslations/en';
import { EsTranslation } from './shared/culture/traslations/es';
import { FrTranslation } from './shared/culture/traslations/fr';
import { DeTranslation } from './shared/culture/traslations/de';
import { RolesEnum } from './shared/enums/roles.enum';
import { TenantTypeEnum } from 'environments/tenant-type.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  public loaderId = MAIN_LOADER_ID;
  public initialized = false;
  public block = false;
  public workInProgressTitle = "";
  private subscription = new Subscription();

  constructor(
    private _loaderService: LoaderService,
    private _core: CoreService,
    private _router: Router,
    private _auth: AuthService,
    private _translationService: TranslateService,
    private _coreTranslationService: CoreTranslationService,
    private ApplicationInsightsService: ApplicationInsightsService
  ) {
    this.checkAuthSubscribe();

    this._loaderService.showLoader(this.loaderId);
    this._router.events.subscribe(val => {
      if (val instanceof NavigationStart && val.url.indexOf(PLP_SCROLL_PROP) < 0)
        this._loaderService.showLoader(this.loaderId);
      else if (val instanceof NavigationCancel || val instanceof NavigationEnd)
        this._loaderService.dismissLoader(this.loaderId);
    });
  }

  ngOnInit(): void {
    setTimeout(() => this.langInitAndSetBlock());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private langInitAndSetBlock() {
    const culture = new CultureList();
    this.subscription.add(this._core.userInfoChanged$.subscribe(data => {
      if (data) {
        // const block = (environment.blockedTenants?.some(x => x == UtilityFunctions.getEnvironmentTenant(data.tenant?.id)?.tenantType) && !UtilityFunctions.IsAdminOrStoreOwner(this._core.userInfoChangedValue)) || (UtilityFunctions.getEnvironmentTenant(data.tenant?.id)?.tenantType === TenantTypeEnum.KappaFrance && !UtilityFunctions.superAdminEmails().some(x => x === this._core.userInfoChangedValue.email));
        const block = environment.blockedTenants?.some(x => x == UtilityFunctions.getEnvironmentTenant(data.tenant?.id)?.tenantType) && !UtilityFunctions.IsAdminOrStoreOwner(this._core.userInfoChangedValue);
        // const block = environment.blockedTenants?.some(x => x == UtilityFunctions.getEnvironmentTenant(data.tenant?.id)?.tenantType) && !UtilityFunctions.superAdminEmails().some(x => x === this._core.userInfoChangedValue.email);
        if (block) {
          this._translationService.addLangs(culture.getShortTitleList());
          this._coreTranslationService.translate(ItTranslation, EnTranslation, EsTranslation, FrTranslation, DeTranslation);
          const fromHour = '18:00';
          const fromDate = '26/11/2025';
          const toHour = '10:00';
          const toDate = '08/12/2025';
          this._translationService.setDefaultLang(culture.getShortTitle(data.culture));
          this.workInProgressTitle = this._translationService.instant('WORK_IN_PROGRESS_TITLE', { fromHour, fromDate, toHour, toDate })
          this.block = block;
        }
      }
    }));
  }

  private checkAuthSubscribe() {
    this.subscription.add(this._core.userInfoChanged$.pipe(filter(data => !!data))
      .subscribe(data => this.ApplicationInsightsService.setUserId(data.identityId)));
    this.subscription.add(this._auth.isLogged.subscribe(data => this.initialized = data));
  }
}
